var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"counter-container"},[_c('span',[_vm._v(_vm._s(_vm.label))]),_vm._v(" : "),_c('span',[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }